<template>
  <span
    class="badge"
    :class="[
      variantClasses,
      sizeClasses,
      {
        'badge-dot': dot
      }
    ]"
  >
    <span v-if="dot" class="badge-dot-indicator" />
    <slot />
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: val =>
      ['default', 'primary', 'accent', 'success', 'warning', 'error', 'outline'].includes(val)
  },
  size: {
    type: String,
    default: 'md',
    validator: val => ['sm', 'md', 'lg'].includes(val)
  },
  dot: {
    type: Boolean,
    default: false
  }
})

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'primary':
      return 'bg-primary-fixed text-on-primary-fixed'
    case 'accent':
      return 'bg-secondary-fixed text-on-secondary-fixed'
    case 'success':
      return 'bg-green-500 text-white'
    case 'warning':
      return 'bg-tertiary-fixed text-on-tertiary-fixed'
    case 'error':
      return 'bg-error-container text-on-error-container'
    case 'outline':
      return 'bg-transparent border border-outline-variant text-on-surface-variant'
    case 'default':
    default:
      return 'bg-surface-container-high text-on-surface-variant'
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'text-xs px-2 py-1'
    case 'lg':
      return 'text-sm px-3 py-2'
    case 'md':
    default:
      return 'text-xs px-2.5 py-1.5'
  }
})
</script>

<style scoped>
.badge {
  @apply inline-flex items-center justify-center rounded-full font-medium whitespace-nowrap;
}

.badge-dot {
  @apply relative pl-3;
}

.badge-dot-indicator {
  @apply absolute left-1.5 top-1/2 transform -translate-y-1/2 w-2 h-2 rounded-full bg-current;
}
</style>
